import IconErrorSolid from '@apollo/icons/small/IconErrorSolid.svg';
import { Badge, Heading, Text, Tooltip } from '@apollo/orbit';
import React from 'react';

import { toAbsoluteMoment } from 'src/components/affectedOperations/affectedOperationsHelpers';
import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { format } from 'src/lib/format';
import { Timestamp } from 'src/lib/graphqlTypes/customScalarTypes';

export const OperationCheckDetailsHeader = ({
  numberOfAffectedOperations,
  numberOfCheckedOperations,
  from = null,
  to = null,
  createdAt = null,
}: {
  numberOfAffectedOperations: number;
  numberOfCheckedOperations: number;
  createdAt: Timestamp['output'] | null;
  from: Timestamp['output'] | null | undefined;
  to: Timestamp['output'] | null | undefined;
}) => {
  let timeFrom = null;
  let timeTo = null;

  if (createdAt && from && to) {
    timeFrom = toAbsoluteMoment(from, createdAt);
    timeTo = toAbsoluteMoment(to, createdAt);
  }

  return (
    <div>
      <div className="mb-2 flex items-center">
        <Heading size="xl" className="mr-2">
          Operations
        </Heading>
        {numberOfAffectedOperations > 0 && (
          <Tooltip label={`${numberOfAffectedOperations} affected operations`}>
            <Badge variant="error" icon={<IconErrorSolid />} className="mt-1">
              {numberOfAffectedOperations}
            </Badge>
          </Tooltip>
        )}
      </div>
      {timeFrom && timeTo && (
        <Text variant="subtitle">
          {numberOfCheckedOperations}{' '}
          {format.pluralize(numberOfCheckedOperations, 'operation')} checked
          between <LocalTimestamp className="text-body-sb" value={timeFrom} />
          {' — '}
          <LocalTimestamp className="text-body-sb" value={timeTo} />
        </Text>
      )}
    </div>
  );
};
